require('../modules/es6.symbol');
require('../modules/es6.object.to-string');
module.exports = require('../modules/_core').Symbol;



//////////////////
// WEBPACK FOOTER
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/~/core-js/es6/symbol.js
// module id = ../../../../core-js/es6/symbol.js
// module chunks = 0